import { render, staticRenderFns } from "./CreateForm3.vue?vue&type=template&id=450e89ac&"
import script from "./CreateForm3.vue?vue&type=script&lang=js&"
export * from "./CreateForm3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports